import { relocateMailEmlStorage } from "@/lib/api/storage";
import { relocateMessageBodyCache } from "@/lib/cache/messageBodyCache";
import { notifyMailStorageUpdated } from "@/lib/storage/mailStorageEvents";

/** Déplace les archives .eml DD02 après un move IMAP réussi. */
export async function relocateStoredMessages(
  accountId: number,
  uids: number[],
  fromFolder: string,
  toFolder: string
): Promise<void> {
  if (fromFolder === toFolder || uids.length === 0) return;

  const res = await relocateMailEmlStorage({
    accountId,
    fromFolder,
    toFolder,
    uids,
  });

  for (const uid of uids) {
    if (uid <= 0) continue;
    relocateMessageBodyCache(accountId, uid, fromFolder, toFolder);
  }

  if (res.ok && res.data.moved > 0) {
    notifyMailStorageUpdated(accountId, toFolder);
  }
}
